import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = ({ onToggleSidebar }) => {
  const { logout, user } = useAuth();

  return (
    <header className="admin-header">
      <div className="header-left">
        <button className="mobile-toggle" onClick={onToggleSidebar}>
          <i className="fas fa-bars"></i>
        </button>
        <h1 className="header-title">VaahanBuddy Console</h1>
      </div>
      <div className="header-right">
        <div className="user-info">
          <div className="user-badge">
            <div className="user-avatar">
              {user?.name ? user.name.charAt(0).toUpperCase() : 'A'}
            </div>
            <span className="user-role">
              {user?.isSuperAdmin ? 'Super Admin' : 'Administrator'}
            </span>
          </div>
          <button className="logout-btn" onClick={logout}>
            <i className="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;